// @ts-nocheck


import React from 'react';
import styled, { css } from 'styled-components';






const B = styled(({ fontSize, ...props }) =>
<b {...props} />
)`
  font-weight: 700;
  ${({ fontSize = 'inherit' }) => css`
    font-size: ${fontSize};
  `}
`;

export default B;
